import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { GridLayout } from "../../../../../../common/GridLayout";
import LotSubTabs from "./LotSubTabs";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import { Button } from 'devextreme-react/button';
import GridLayoutManager from "../../../../../../gridLayoutCustomization/GridLayoutManager";
const LotSearchFormResult = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const childRef = useRef();
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "dc96adca-c885-497d-81b8-06753eff86a7";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const onSelectionChanged = ({ selectedRowsData }) => {
        const selectedRowData = selectedRowsData[0];
        if (childRef.current) {
            childRef.current.updateData(selectedRowData);
        }
    };

    return (
        <div>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                searchExpr="status"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
                scrolling={{ mode: "standard" }}
                onSelectionChanged={onSelectionChanged}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <ColumnHeaderFilter />
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="single" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Scrolling rowRenderingMode="virtual" />
                <FilterRow visible={true} />
                <Scrolling mode="virtual" />
                <Column dataField="lotCode" caption='Lot' ></Column>
                <Column dataField="lotDescription1" caption='Description1' ></Column>
                <Column dataField="lotDescription2" caption='Description2' ></Column>
                <Column dataField="itemCode" caption='Item' ></Column>
                <Column dataField="customerCode" caption='Customer' ></Column>
                <Column dataField="customerName" caption='Customer Name' ></Column>
                <Column dataField="lotAvailable" caption='Available Lot' ></Column>
                <Column dataField="lotStatus" caption="Lot Status" visible={false} />
                <Column dataField="dateIntroduce" caption="Date Introduced" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="dateAvailable" caption="Date Available" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="locationCode" caption="Location Code" visible={false} />
                <Column dataField="netAvailable" caption="Net Available" visible={false} dataType="number" format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }} />
                <Column dataField="lotUDFCode1" caption="Code 1" visible={false} />
                <Column dataField="lotUDFCode2" caption="Code 2" visible={false} />
                <Column dataField="lotUDFCode3" caption="Code 3" visible={false} />
                <Column dataField="lotUDFCode4" caption="Code 4" visible={false} />
                <Column dataField="lotUDFCode5" caption="Code 5" visible={false} />
                <Column dataField="lotUDFCode6" caption="Code 6" visible={false} />
                <Column dataField="lotUDFCode7" caption="Code 7" visible={false} />
                <Column dataField="lotUDFCode8" caption="Code 8" visible={false} />
                <Column dataField="lotUDFCode9" caption="Code 9" visible={false} />
                <Column dataField="lotUDFCode10" caption="Code 10" visible={false} />
                <Column dataField="lotUDFRef1" caption="Reference 1" visible={false} />
                <Column dataField="lotUDFRef2" caption="Reference 2" visible={false} />
                <Column dataField="lotUDFRef3" caption="Reference 3" visible={false} />
                <Column dataField="lotUDFRef4" caption="Reference 4" visible={false} />
                <Column dataField="lotUDFRef5" caption="Reference 5" visible={false} />
                <Column dataField="lotUDFRef6" caption="Reference 6" visible={false} />
                <Column dataField="lotUDFRef7" caption="Reference 7" visible={false} />
                <Column dataField="lotUDFRef8" caption="Reference 8" visible={false} />
                <Column dataField="lotUDFRef9" caption="Reference 9" visible={false} />
                <Column dataField="lotUDFRef10" caption="Reference 10" visible={false} />
                <Column dataField="lotUDFDate1" caption="Date 1" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="lotUDFDate2" caption="Date 2" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="lotUDFDate3" caption="Date 3" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="lotUDFDate4" caption="Date 4" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="lotUDFDate5" caption="Date 5" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="lotUDFDate6" caption="Date 6" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="lotUDFDate7" caption="Date 7" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="lotUDFDate8" caption="Date 8" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="lotUDFDate9" caption="Date 9" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="lotUDFDate10" caption="Date 10" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="lotUDFQty1" caption="Quantity 1" visible={false} dataType="number" format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }} />
                <Column dataField="lotUDFQty2" caption="Quantity 2" visible={false} dataType="number" format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }} />
                <Column dataField="lotUDFQty3" caption="Quantity 3" visible={false} dataType="number" format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }} />
                <Column dataField="lotUDFQty4" caption="Quantity 4" visible={false} dataType="number" format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }} />
                <Column dataField="lotUDFQty5" caption="Quantity 5" visible={false} dataType="number" format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }} />
                <Column dataField="lotUDFQty6" caption="Quantity 6" visible={false} dataType="number" format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }} />
                <Column dataField="lotUDFQty7" caption="Quantity 7" visible={false} dataType="number" format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }} />
                <Column dataField="lotUDFQty8" caption="Quantity 8" visible={false} dataType="number" format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }} />
                <Column dataField="lotUDFQty9" caption="Quantity 9" visible={false} dataType="number" format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }} />
                <Column dataField="lotUDFQty10" caption="Quantity 10" visible={false} dataType="number" format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }} />
                <Column dataField="lotNetWeightQty" caption="Net Weight Quantity" visible={false} dataType="number" format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }} />
                <Column dataField="lotGrossWeightQty" caption="Gross Weight Quantity" visible={false} dataType="number" format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }} />
                <Column dataField="lotOnHand" caption="Lot On Hand" visible={false} />
                <Column dataField="lotInReceiving" caption="Lot In Receiving" visible={false} />
                <Column dataField="lotOutShipped" caption="Lot Out Shipped" visible={false} />
                <Column dataField="lotOutUnavailable" caption="Lot Out Unavailable" visible={false} />
                <Column dataField="lotInOrdered" caption="Lot In Ordered" visible={false} />
                <Column dataField="lotOutOrdered" caption="Lot Out Ordered" visible={false} />
                <Column dataField="lotInFuture" caption="Lot In Future" visible={false} />
                <Column dataField="lotOutFuture" caption="Lot Out Future" visible={false} />
                <Column dataField="lotFirstReceipt" caption="Lot First Receipt" visible={false} />
                <Column dataField="dateExpiration" caption="Date Expiration" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="unitsPerPackageQuantity" caption="Units Per Package Quantity" visible={false} />
                <Column dataField="piecesPerUnitUOM" caption="Pieces Per Unit UOM" visible={false} />
                <Column dataField="inventoryUnitUOM" caption="Inventory Unit UOM" visible={false} />
                <Column dataField="piecesPerUnitQuantity" caption="Pieces Per Unit Quantity" visible={false} />
                <Column dataField="unitsPerPackageUOM" caption="Units Per Package UOM" visible={false} />
                <Column dataField="grossWeightUOM" caption="Gross Weight UOM" visible={false} />
                <Column dataField="storageBillingStartDate" caption="Storage Billing Start Date" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="storageBillingEndDate" caption="Storage Billing End Date" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="storageBilledDateLast" caption="Storage Billed Date Last" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="prevStorageBilledDateLast" caption="Prev Storage Billed Date Last" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="storageBilledDateNext" caption="Storage Billed Date Next" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="prevStoragebBilledDateNext" caption="Prev Storage Billed Date Next" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="itemDescription1" caption="Item Description 1" visible={false} />
                <Column dataField="itemDescription2" caption="Item Description 2" visible={false} />
                <Column dataField="itemStatus" caption="Item Status" visible={false} />
                <Column dataField="itemClass" caption="Item Class" visible={false} />
                <Column dataField="itemSubClass" caption="Item Sub Class" visible={false} />
                <Column dataField="itemType" caption="Item Type" visible={false} />
                <Column dataField="CustomerAddress1" caption="Customer Address 1" visible={false} />
                <Column dataField="CustomerAddress2" caption="Customer Address 2" visible={false} />
                <Column dataField="CustomerCity" caption="Customer City" visible={false} />
                <Column dataField="CustomerCountry" caption="Customer Country" visible={false} />
                <Column dataField="CustomerState" caption="Customer State" visible={false} />
                <Column dataField="CustomerZip" caption="Customer Zip" visible={false} />
                <Column dataField="CustomerPhone" caption="Customer Phone" visible={false} />
                <Column dataField="CustomerFax" caption="Customer Fax" visible={false} />
                <Column dataField="CustomerEmail" caption="Customer Email" visible={false} />
                <Column dataField="Department" caption="Department" visible={false} />
                <Column dataField="DepartmentDescription" caption="Department Description" visible={false} />
                <Column dataField="Job" caption="Job" visible={false} />
                <Column dataField="JobDescription" caption="Job Description" visible={false} />
                <Column dataField="Fund" caption="Fund" visible={false} />
                <Column dataField="FundDescription" caption="Fund Description" visible={false} />
                <Toolbar>

                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
            <LotSubTabs ref={childRef} accessToken={accessToken} />
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(LotSearchFormResult);